import { render, staticRenderFns } from "./NoComissionPay.vue?vue&type=template&id=61ad896d&scoped=true&"
import script from "./NoComissionPay.vue?vue&type=script&lang=js&"
export * from "./NoComissionPay.vue?vue&type=script&lang=js&"
import style0 from "./NoComissionPay.vue?vue&type=style&index=0&id=61ad896d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ad896d",
  null
  
)

export default component.exports